import { cloneDeep } from 'lodash';
import { UserShortcutEnum } from 'projects/workspace/src/app/hrm/enums';
import { ProductTypes } from '../../../products/product-types';
import { ShortcutConfigModel } from './shortcuts-config-item.model';
import { AppNameEnum } from '../../../start-screen-page/launchpad.model';

export function userAvailableShortcutsHelper(shortcuts: UserShortcutEnum[], config: any = ShortcutsConfig()): any { // todo model
  const availableGroup = cloneDeep(availableShortcutsGroupConfig);

  shortcuts.forEach((shortcut: UserShortcutEnum) => {
    const matchedGroup = availableGroup.find(g => g.group.includes(shortcut));
    if (matchedGroup && config[shortcut]) {
      matchedGroup.shortcuts.push(config[shortcut]);
    }
  });

  return availableGroup;
}

export const availableShortcutsGroupConfig = [ // todo model
  {
    title: 'MODULE.TRADE',
    icon: 'cash',
    group: [
      UserShortcutEnum.OFFERS,
      UserShortcutEnum.SALES_ORDERS,
      UserShortcutEnum.PURCHASE_ORDERS,
      UserShortcutEnum.PRICES,
      UserShortcutEnum.RETURNS,
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.E_COMMERCE',
    icon: 'shopping-cart',
    group: [
      UserShortcutEnum.ECOMMERCE_ORDERS,
      UserShortcutEnum.ECOMMERCE_PRODUCTS,
      UserShortcutEnum.ECOMMERCE_PRICES,
      UserShortcutEnum.ECOMMERCE_PARTNERS,
      // UserShortcutEnum.ECOMMERCE_CORPORATE_PARTNERS,
      // UserShortcutEnum.ECOMMERCE_PRIVATE_PARTNERS,
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.SERVICES',
    icon: 'checklist',
    group: [
      UserShortcutEnum.TIME_TRACKING,
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.ACCOUNTING',
    icon: 'calculator',
    group: [
      UserShortcutEnum.OUTGOING_INVOICES,
      UserShortcutEnum.INCOMING_INVOICES,
      UserShortcutEnum.PAYMENTS,
      UserShortcutEnum.SUBSCRIPTIONS,
      UserShortcutEnum.SCHEDULED_PAYMENT,
      UserShortcutEnum.PAYMENT_CALENDAR,
      UserShortcutEnum.CREDIT_NOTES,
      UserShortcutEnum.OPEN_ITEM_LIST,
      UserShortcutEnum.REPORTING_PERIODS,
      UserShortcutEnum.SCHEDULE_PAYMENTS,
      UserShortcutEnum.FIXED_ASSETS,
      UserShortcutEnum.VAT_RETURN,
      UserShortcutEnum.GOODS_REGISTER,
      UserShortcutEnum.COST_CENTER,
      UserShortcutEnum.BANK_ACCOUNT,
      UserShortcutEnum.GL_ACCOUNT,
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.WAREHOUSE',
    icon: 'warehouse',
    group: [
      UserShortcutEnum.STOCK_STATUS,
      UserShortcutEnum.INCOMING_DELIVERIES,
      UserShortcutEnum.OUTGOING_DELIVERIES,
      UserShortcutEnum.TRANSACTIONS,
      UserShortcutEnum.MANAGEMENT,
      UserShortcutEnum.STOCKTAKING,
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.PRODUCTS',
    icon: 'box',
    group: [
      UserShortcutEnum.PRODUCTS,
      // UserShortcutEnum.GOODS,
      // UserShortcutEnum.SERVICES,
      // UserShortcutEnum.DIGITAL_PRODUCTS,
      // UserShortcutEnum.BUNDLES,
      UserShortcutEnum.CATEGORIES,
      UserShortcutEnum.GENERAL_PRODUCTS,
      UserShortcutEnum.PRODUCT_SETTINGS,
      UserShortcutEnum.SCANNED_BARCODES
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.PARTNERS',
    icon: 'heart',
    group: [
      UserShortcutEnum.PARTNERS,
      // UserShortcutEnum.CORPORATE_PARTNERS,
      // UserShortcutEnum.PRIVATE_PARTNERS,
      UserShortcutEnum.PARTNER_SETTINGS
    ],
    shortcuts: []
  },
  // {
  //   title: 'MODULE.TEAM',
  //   icon: 'people',
  //   group: [
  //     UserShortcutEnum.EMPLOYEES
  //   ]
  //   ,
  //   shortcuts: []
  // },
  {
    title: 'MODULE.ANALYTICS',
    icon: 'business-intelligence',
    group: [
      // UserShortcutEnum.TRADE_DATA,
      UserShortcutEnum.ACCOUNTING_DATA,
      UserShortcutEnum.CASHFLOW,
      // UserShortcutEnum.WAREHOUSE_DATA,
    ],
    shortcuts: []
  },
  {
    title: 'MODULE.ADMINISTRATION',
    icon: 'settings-2x',
    group: [
      UserShortcutEnum.COMPANY_PROFILE,
      UserShortcutEnum.EMPLOYEES
    ],
    shortcuts: []
  },
];

export function ShortcutsConfig(
  showProductsSettings: boolean = false,
  showPartnersSettings: boolean = false,
  showWarehouseSettings: boolean = false,
  showAccountingSettings: boolean = false,
  showWholesaleSettings: boolean = false,
  showServicesSettings: boolean = false,
  showGoods: boolean = false,
  showServices: boolean = false,
  showDigitalProducts: boolean = false,
  showBundles: boolean = false,
  showCorporatePartners: boolean = false,
  showPrivatePartners: boolean = false,
  showSalesPrices: boolean = false,
  showPurchasePrices: boolean = false,
): ShortcutConfigModel {
  return {
    // TRADE
    [UserShortcutEnum.OFFERS]: {
      key: UserShortcutEnum.OFFERS,
      appName: AppNameEnum.OFFERS,
      title: 'APP.OFFERS',
      icon: 'offer',
      color: 'yellow',
      routerLink: '/trade/offers',
      action: 'createNewOffer',
    },
    [UserShortcutEnum.SALES_ORDERS]: {
      key: UserShortcutEnum.SALES_ORDERS,
      appName: AppNameEnum.SALES_ORDERS,
      title: 'APP.SALES_ORDERS',
      icon: 'sales-order',
      color: 'yellow',
      routerLink: '/trade/sales-order',
      action: 'createNewOrder',
    },
    [UserShortcutEnum.PURCHASE_ORDERS]: {
      key: UserShortcutEnum.PURCHASE_ORDERS,
      appName: AppNameEnum.PURCHASE_ORDERS,
      title: 'APP.PURCHASE_ORDERS',
      icon: 'purchase-order',
      color: 'yellow',
      routerLink: '/trade/purchase-order',
      action: 'createNewPurchaseOrder',
    },
    [UserShortcutEnum.PRICES]: {
      key: UserShortcutEnum.PRICES,
      appName: AppNameEnum.PRICES,
      title: 'APP.PRICES',
      icon: 'pricetag',
      color: 'yellow',
      // routerLink: showSalesPrices ? '/trade/prices/sales' : '/trade/prices/purchase',
      subitems: [
        {
          title: 'PRICE.SALES_PRICES',
          routerLink: '/trade/prices/sales',
          show: showSalesPrices
        },
        {
          title: 'PRICE.PURCHASE_PRICES',
          routerLink: '/trade/prices/purchase',
          show: showPurchasePrices
        },
      ].filter(subitem => subitem.show)
    },
    [UserShortcutEnum.RETURNS]: {
      key: UserShortcutEnum.RETURNS,
      appName: AppNameEnum.RETURNS,
      title: 'APP.RETURNS',
      icon: 'exchange-return',
      color: 'yellow',
      routerLink: '/trade/exchanges-and-returns',
      action: 'createNewERA',
    },

    // ECOMMERCE
    [UserShortcutEnum.ECOMMERCE_ORDERS]: {
      key: UserShortcutEnum.ECOMMERCE_ORDERS,
      appName: AppNameEnum.E_COMMERCE,
      title: 'ECOMMERCE.ECO_ORDERS_2',
      icon: 'sales-order',
      color: 'red',
      routerLink: '/e-commerce/orders',
    },
    [UserShortcutEnum.ECOMMERCE_PARTNERS]: {
      key: UserShortcutEnum.ECOMMERCE_PARTNERS,
      title: 'LAUNCH_PAD.ECO_CUSTOMERS',
      icon: 'factory',
      color: 'red',
      subitems: [
        {
          title: 'APP.CORPORATE_PARTNERS_1',
          routerLink: '/partners-new/corporate',
          action: 'createNewPartner',
          show: showCorporatePartners
        },
        {
          title: 'APP.PRIVATE_PARTNERS',
          routerLink: '/partners-new/private',
          action: 'createNewPrivatePartner',
          show: showPrivatePartners
        },
      ].filter(subitem => subitem.show),
    },

    // SUBSCRIPTIONS
    [UserShortcutEnum.TIME_TRACKING]: {
      key: UserShortcutEnum.TIME_TRACKING,
      appName: AppNameEnum.TIME_TRACKING,
      title: 'APP.TIME_TRACKING',
      icon: 'timer',
      color: 'green',
      routerLink: '/services/time-tracking',
      action: 'onLogTimeClick',
    },

    // ACCOUNTING
    [UserShortcutEnum.OUTGOING_INVOICES]: {
      key: UserShortcutEnum.OUTGOING_INVOICES,
      appName: AppNameEnum.OUTGOING_INVOICES,
      title: 'APP.OUTGOING_INVOICES',
      icon: 'outgoing-invoice',
      color: 'violet',
      routerLink: '/accounting/outgoing-invoice',
      action: 'createNewInvoice',
    },
    [UserShortcutEnum.INCOMING_INVOICES]: {
      key: UserShortcutEnum.INCOMING_INVOICES,
      appName: AppNameEnum.INCOMING_INVOICES,
      title: 'APP.INCOMING_INVOICES',
      icon: 'incoming-invoice',
      color: 'violet',
      routerLink: '/accounting/incoming-invoice',
      action: 'createNewIncomingInvoice',
    },
    [UserShortcutEnum.PAYMENTS]: {
      key: UserShortcutEnum.PAYMENTS,
      appName: AppNameEnum.PAYMENTS,
      title: 'APP.PAYMENTS',
      icon: 'payment',
      color: 'violet',
      routerLink: '/accounting/payments',
    },
    [UserShortcutEnum.SUBSCRIPTIONS]: {
      key: UserShortcutEnum.SUBSCRIPTIONS,
      appName: AppNameEnum.SUBSCRIPTIONS,
      title: 'APP.RECURRING_INVOICES',
      icon: 'subscriptions',
      color: 'violet',
      routerLink: '/accounting/recurring-invoice',
      action: 'createNewSubscription',
    },
    [UserShortcutEnum.SCHEDULED_PAYMENT]: {
      key: UserShortcutEnum.SCHEDULED_PAYMENT,
      appName: AppNameEnum.SCHEDULED_PAYMENTS,
      title: 'SCHEDULED_PAYMENT.SCHEDULED_PAYMENTS',
      icon: 'recurring-costs',
      color: 'violet',
      routerLink: '/accounting/scheduled-payment',
      action: 'createNewScheduledPayment',
    },
    [UserShortcutEnum.PAYMENT_CALENDAR]: {
      key: UserShortcutEnum.PAYMENT_CALENDAR,
      appName: AppNameEnum.PAYMENT_CALENDAR,
      title: 'APP.PAYMENTS_CALENDAR',
      icon: 'payments-calendar',
      color: 'violet',
      routerLink: '/accounting/payments-calendar',
    },
    [UserShortcutEnum.CREDIT_NOTES]: {
      key: UserShortcutEnum.CREDIT_NOTES,
      appName: AppNameEnum.CREDIT_NOTES,
      title: 'APP.CREDIT_NOTES',
      icon: 'credit-note',
      color: 'violet',
      routerLink: '/accounting/credit-note',
      action: 'createNewCreditNote',
    },
    [UserShortcutEnum.OPEN_ITEM_LIST]: {
      key: UserShortcutEnum.OPEN_ITEM_LIST,
      appName: AppNameEnum.OPEN_ITEM_LIST,
      title: 'APP.OPEN_ITEM_LIST',
      icon: 'open-items-list',
      color: 'violet',
      routerLink: '/accounting/open-items',
    },
    [UserShortcutEnum.REPORTING_PERIODS]: {
      key: UserShortcutEnum.REPORTING_PERIODS,
      appName: AppNameEnum.REPORTING_PERIODS,
      title: 'REPORTING_PERIODS.REPORTING_PERIODS',
      icon: 'accountant-report',
      color: 'violet',
      routerLink: '/accounting/reporting-periods',
    },
    [UserShortcutEnum.FIXED_ASSETS]: {
      key: UserShortcutEnum.FIXED_ASSETS,
      appName: AppNameEnum.FIXED_ASSETS,
      title: 'FIXED_ASSETS.ASSETS_DIRECTORY',
      icon: 'fixed-assets',
      color: 'violet',
      routerLink: '/accounting/fixed-assets',
    },
    [UserShortcutEnum.VAT_RETURN]: {
      key: UserShortcutEnum.VAT_RETURN,
      appName: AppNameEnum.VAT_REPORTS,
      title: 'TAX_REPORTS.PRELIMINARY_RETURN',
      icon: 'tax-reports',
      color: 'violet',
      routerLink: '/accounting/vat-reports',
    },
    [UserShortcutEnum.GOODS_REGISTER]: {
      key: UserShortcutEnum.GOODS_REGISTER,
      appName: AppNameEnum.GOODS_REGISTER,
      title: 'GOODS_REGISTER.GOODS_REGISTER',
      icon: 'goods-register',
      color: 'violet',
      routerLink: '/accounting/goods-register',
    },
    [UserShortcutEnum.COST_CENTER]: {
      key: UserShortcutEnum.COST_CENTER,
      appName: AppNameEnum.COST_CENTER,
      title: 'COST_CENTER.COST_CENTERS',
      icon: 'costs_center',
      color: 'violet',
      routerLink: '/accounting/cost-center',
    },
    [UserShortcutEnum.BANK_ACCOUNT]: {
      key: UserShortcutEnum.BANK_ACCOUNT,
      appName: AppNameEnum.BANK_ACCOUNT,
      title: 'APP.BANK_ACCOUNTS',
      icon: 'account',
      color: 'violet',
      routerLink: '/accounting/bank-accounts',
      action: 'createBankAccount',
    },
    [UserShortcutEnum.GL_ACCOUNT]: {
      key: UserShortcutEnum.GL_ACCOUNT,
      appName: AppNameEnum.GL_ACCOUNT,
      title: 'GL_ACCOUNTS.LEDGER_ACCOUNTS',
      icon: 'gl-accounts',
      color: 'violet',
      routerLink: '/accounting/gl-accounts',
    },

    // WAREHOUSE
    [UserShortcutEnum.STOCK_STATUS]: {
      key: UserShortcutEnum.STOCK_STATUS,
      appName: AppNameEnum.STOCK_STATUS,
      title: 'APP.STOCK_STATUS',
      icon: 'cubes',
      color: 'orange',
      routerLink: '/warehouse/stock-status',
    },
    [UserShortcutEnum.INCOMING_DELIVERIES]: {
      key: UserShortcutEnum.INCOMING_DELIVERIES,
      appName: AppNameEnum.INCOMING_DELIVERIES,
      title: 'APP.INCOMING_DELIVERIES',
      icon: 'incoming-delivery',
      color: 'orange',
      routerLink: '/warehouse/incoming-delivery',
    },
    [UserShortcutEnum.OUTGOING_DELIVERIES]: {
      key: UserShortcutEnum.OUTGOING_DELIVERIES,
      appName: AppNameEnum.OUTGOING_DELIVERIES,
      title: 'APP.OUTGOING_DELIVERIES',
      icon: 'outgoing-delivery',
      color: 'orange',
      routerLink: '/warehouse/outgoing-delivery',
      action: 'createNewDeliveryNote',
    },
    [UserShortcutEnum.STOCKTAKING]: {
      key: UserShortcutEnum.STOCKTAKING,
      appName: AppNameEnum.STOCKTAKING,
      title: 'STOCKTAKING.STOCKTAKING',
      icon: 'stocktaking',
      color: 'orange',
      routerLink: '/warehouse/stocktaking',
    },
    [UserShortcutEnum.TRANSACTIONS]: {
      key: UserShortcutEnum.TRANSACTIONS,
      appName: AppNameEnum.TRANSACTIONS,
      title: 'APP.TRANSACTIONS',
      icon: 'stocktransfer',
      color: 'orange',
      routerLink: '/warehouse/transactions',
      action: 'createTransaction',
    },
    [UserShortcutEnum.MANAGEMENT]: {
      key: UserShortcutEnum.MANAGEMENT,
      title: 'APP.MANAGEMENT',
      icon: 'warehouse',
      color: 'orange',
      routerLink: '/warehouse/warehouse-profile',
    },

    // PRODUCTS
    [UserShortcutEnum.PRODUCTS]: {
      key: UserShortcutEnum.PRODUCTS,
      title: 'APP.PRODUCTS',
      icon: 'box',
      color: 'purple',
      // routerLink: `/products`,
      subitemsOpened: false,
      subitems: [
        {
          title: 'COMMON.GOODS',
          routerLink: `/products/${ProductTypes.GOODS}`,
          action: 'createNewProduct',
          show: showGoods
        },
        {
          title: 'APP.SERVICES',
          routerLink: `/products/${ProductTypes.SERVICES}`,
          action: 'createNewService',
          show: showServices
        },
        {
          title: 'APP.DIGITAL_PRODUCTS',
          routerLink: `/products/${ProductTypes.DIGITAL}`,
          action: 'createNewDigitalProduct',
          show: showDigitalProducts
        },
        {
          title: 'BUNDLES.BUNDLES',
          routerLink: `/products/${ProductTypes.BUNDLE}`,
          action: 'createNewBundleProduct',
          show: showBundles
        }
      ].filter(subitem => subitem.show)
    },
    [UserShortcutEnum.GENERAL_PRODUCTS]: {
      key: UserShortcutEnum.GENERAL_PRODUCTS,
      appName: AppNameEnum.GENERAL_PRODUCTS,
      title: 'GL_ACCOUNTS.GENERAL_PRODUCTS',
      icon: 'dashboard',
      color: 'purple',
      routerLink: '/products/general-products',
    },
    [UserShortcutEnum.CATEGORIES]: {
      key: UserShortcutEnum.CATEGORIES,
      appName: AppNameEnum.CATEGORIES,
      title: 'APP.CATEGORIES',
      icon: 'folder-open',
      color: 'purple',
      routerLink: `/products/settings/categories/${ProductTypes.GOODS}`,
    },
    [UserShortcutEnum.PRODUCT_SETTINGS]: {
      key: UserShortcutEnum.PRODUCT_SETTINGS,
      appName: AppNameEnum.PRODUCTS_SETTINGS,
      title: 'SETTINGS.PRODUCTS_SETTINGS',
      icon: 'options-2',
      color: 'purple',
      routerLink: '/products/products-settings',
    },

    // PARTNERS
    [UserShortcutEnum.PARTNERS]: {
      key: UserShortcutEnum.PARTNERS,
      title: 'SANDBOX.BUSINESS_PARTNERS',
      icon: 'factory',
      color: 'brown',
      // routerLink: '/partners-new/corporate',
      subitemsOpened: false,
      subitems: [
        {
          title: 'APP.CORPORATE_PARTNERS_1',
          routerLink: '/partners-new/corporate',
          action: 'createNewPartner',
          show: showCorporatePartners
        },
        {
          title: 'APP.PRIVATE_PARTNERS',
          routerLink: '/partners-new/private',
          action: 'createNewPrivatePartner',
          show: showPrivatePartners
        },
      ].filter(subitem => subitem.show),
    },
    [UserShortcutEnum.PARTNER_SETTINGS]: {
      key: UserShortcutEnum.PARTNER_SETTINGS,
      appName: AppNameEnum.PARTNERS_SETTINGS,
      title: 'SETTINGS.PARTNERS_SETTINGS',
      icon: 'options-2',
      color: 'brown',
      routerLink: '/partners-new/settings',
    },

    // TEAM
    [UserShortcutEnum.EMPLOYEES]: {
      key: UserShortcutEnum.EMPLOYEES,
      appName: AppNameEnum.EMPLOYEES,
      title: 'APP.EMPLOYEES',
      icon: 'people',
      color: 'sky',
      routerLink: '/team',
      action: 'createNewEmployee',
    },

    // ANALYTICS
    [UserShortcutEnum.TRADE_DATA]: {
      key: UserShortcutEnum.TRADE_DATA,
      appName: AppNameEnum.TRADE_DASHBOARD,
      title: 'DASHBOARDS.TRADE_DATA',
      icon: 'cash',
      color: 'mint',
      routerLink: '/analytics/trade-dashboard',
    },
    [UserShortcutEnum.ACCOUNTING_DATA]: {
      key: UserShortcutEnum.ACCOUNTING_DATA,
      appName: AppNameEnum.ACCOUNTING_DASHBOARD,
      title: 'DASHBOARDS.ACCOUNTING_DATA',
      icon: 'calculator',
      color: 'mint',
      routerLink: '/analytics/accounting-dashboard',
    },
    [UserShortcutEnum.WAREHOUSE_DATA]: {
      key: UserShortcutEnum.WAREHOUSE_DATA,
      appName: AppNameEnum.WAREHOUSE_DASHBOARD,
      title: 'DASHBOARDS.WAREHOUSE_DATA',
      icon: 'warehouse',
      color: 'mint',
      routerLink: '/analytics/warehouse-dashboard',
    },

    // ADMINISTRATION
    [UserShortcutEnum.COMPANY_PROFILE]: {
      key: UserShortcutEnum.COMPANY_PROFILE,
      appName: AppNameEnum.ADMINISTRATION,
      title: 'ADMINISTRATION.COMPANY_PROFILE',
      icon: 'factory',
      color: 'grey',
      routerLink: '/administration/company-profile',
    },
  };
}

export const quickActionsConfig = { // todo model
// TRADE
  [UserShortcutEnum.OFFERS]: {
    key: UserShortcutEnum.OFFERS,
    title: 'BUTTON.CREATE_OFFER',
    icon: 'offer',
    color: 'yellow',
    action: 'createNewOffer'
  },
  [UserShortcutEnum.SALES_ORDERS]: {
    key: UserShortcutEnum.SALES_ORDERS,
    title: 'OFFER.FORM.CREATE_SO',
    icon: 'sales-order',
    color: 'yellow',
    action: 'createNewOrder'
  },
  [UserShortcutEnum.PURCHASE_ORDERS]: {
    key: UserShortcutEnum.PURCHASE_ORDERS,
    title: 'BUTTON.CREATE_PO',
    icon: 'purchase-order',
    color: 'yellow',
    action: 'createNewPurchaseOrder'
  },
  [UserShortcutEnum.RETURNS]: {
    key: UserShortcutEnum.RETURNS,
    title: 'BUTTON.CREATE_RETURN',
    icon: 'exchange-return',
    color: 'yellow',
    action: 'createNewERA',
  },
  // SUBSCRIPTIONS
  [UserShortcutEnum.TIME_TRACKING]: {
    key: UserShortcutEnum.TIME_TRACKING,
    title: 'BUTTON.TRACK_TIME',
    icon: 'timer',
    color: 'green',
    action: 'onLogTimeClick',
  },
  // ACCOUNTING
  [UserShortcutEnum.OUTGOING_INVOICES]: {
    key: UserShortcutEnum.OUTGOING_INVOICES,
    title: 'BUTTON.CREATE_OIN',
    icon: 'outgoing-invoice',
    color: 'violet',
    action: 'createNewInvoice'
  },
  [UserShortcutEnum.INCOMING_INVOICES]: {
    key: UserShortcutEnum.INCOMING_INVOICES,
    title: 'BUTTON.CREATE_INCOMING_INVOICE',
    icon: 'incoming-invoice',
    color: 'violet',
    action: 'createNewIncomingInvoice'
  },
  [UserShortcutEnum.SUBSCRIPTIONS]: {
    key: UserShortcutEnum.SUBSCRIPTIONS,
    title: 'BUTTON.CREATE_INVOICE',
    icon: 'subscriptions',
    color: 'violet',
    action: 'createNewSubscription'
  },
  [UserShortcutEnum.SCHEDULE_PAYMENTS]: {
    key: UserShortcutEnum.SCHEDULE_PAYMENTS,
    title: 'SCHEDULED_PAYMENT.CREATE_SCHEDULED_PAYMENT',
    icon: 'recurring-costs',
    color: 'violet',
    action: 'createNewScheduledPayment'
  },
  [UserShortcutEnum.CREDIT_NOTES]: {
    key: UserShortcutEnum.CREDIT_NOTES,
    title: 'BUTTON.CREATE_CREDIT_NOTE',
    icon: 'credit-note',
    color: 'violet',
    action: 'createNewCreditNote'
  },
  [UserShortcutEnum.CASHFLOW]: {
    key: UserShortcutEnum.CASHFLOW,
    title: 'CASH_FLOW.CASH_FLOW',
    icon: 'cashflow',
    color: 'violet',
    routerLink: '/accounting/cashflow',
  },
  // WAREHOUSE
  [UserShortcutEnum.OUTGOING_DELIVERIES]: {
    key: UserShortcutEnum.OUTGOING_DELIVERIES,
    title: 'FORM.CREATE_DELIVERY_NOTE',
    icon: 'outgoing-delivery',
    color: 'orange',
    action: 'createNewDeliveryNote'
  },
  // PRODUCTS
  // [UserShortcutEnum.GOODS]: {
  //   key: UserShortcutEnum.GOODS,
  //   title: 'BUTTON.CREATE_PRODUCT',
  //   icon: 'box',
  //   color: 'purple',
  //   action: 'createNewProduct'
  // },
  // [UserShortcutEnum.SERVICES]: {
  //   key: UserShortcutEnum.SERVICES,
  //   title: 'BUTTON.CREATE_SERVICE',
  //   icon: 'checklist',
  //   color: 'purple',
  //   action: 'createNewService'
  // },
  // [UserShortcutEnum.DIGITAL_PRODUCTS]: {
  //   key: UserShortcutEnum.DIGITAL_PRODUCTS,
  //   title: 'BUTTON.CREATE_DGT_PRODUCT',
  //   icon: 'digital-product',
  //   color: 'purple',
  //   action: 'createNewDigitalProduct'
  // },
  // [UserShortcutEnum.BUNDLES]: {
  //   key: UserShortcutEnum.BUNDLES,
  //   title: 'BUNDLES.CREATE_BUNDLE',
  //   icon: 'bundle',
  //   color: 'purple',
  //   action: 'createNewBundleProduct'
  // },
  [UserShortcutEnum.GENERAL_PRODUCTS]: {
    key: UserShortcutEnum.GENERAL_PRODUCTS,
    title: 'BUTTON.CREATE_DGT_PRODUCT',
    icon: 'digital-product',
    color: 'purple',
    action: 'createNewDigitalProduct'
  },
  [UserShortcutEnum.SCANNED_BARCODES]: {
    key: UserShortcutEnum.SCANNED_BARCODES,
    title: 'ADMINISTRATION.SCANNED_BARCODES',
    icon: 'barcode',
    color: 'purple',
    action: 'barcodeDialogToggle'
  },
  // PARTNERS
  // [UserShortcutEnum.CORPORATE_PARTNERS]: {
  //   key: UserShortcutEnum.CORPORATE_PARTNERS,
  //   title: 'LAUNCH_PAD.CREATE_COMPANY',
  //   icon: 'factory',
  //   color: 'brown',
  //   action: 'createNewPartner'
  // },
  // [UserShortcutEnum.PRIVATE_PARTNERS]: {
  //   key: UserShortcutEnum.PRIVATE_PARTNERS,
  //   title: 'LAUNCH_PAD.CREATE_PP',
  //   icon: 'person',
  //   color: 'brown',
  //   action: 'createNewPrivatePartner'
  // },
};
